export enum AppointmentReminderStatusEnum {
  "soon" = "soon",
  "started" = "started",
  "doctorJoined" = "doctorJoined",
  "patientJoined" = "patientJoined",
}
